import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target"]

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'IoRouterLink',
  props: {
  linkUrl: {
    type: String,
    required: true,
  },
  linkTarget: {
    type: String,
    required: false,
  },
  linkTitle: {
    type: String,
    required: false,
  },
  active: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  customHandler: {
    type: Function,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const router = useRouter();

const currentPage = computed(() => store.getters['page/page']);
const isActive = computed(() => props.active || (
  currentPage.value && currentPage.value.url === props.linkUrl
));

const routeParts = props.linkUrl.split(window.location.host);
const routePath = routeParts[routeParts.length - 1];

const navigate = (e: Event) => {
  if (router && [undefined, null, '_self'].indexOf(props.linkTarget) >= 0) {
    e.preventDefault();

    if (typeof props.customHandler === 'function') {
      props.customHandler(() => {
        router.push(routePath);
      });
    } else if (`${props.linkUrl || ''}`.trim() !== '' && !props.linkUrl.startsWith(window.location.origin)) {
      window.location.href = routePath;
    } else {
      router.push(routePath);
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: __props.linkUrl,
    target: __props.linkTarget,
    class: _normalizeClass({ 'active': isActive.value }),
    onClick: navigate
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})